// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"fa00e190","57":"2630a88b","86":"2e7798ad","284":"e6211dd8","306":"26c03c12","361":"3181a666","480":"21a1b234","488":"7511eba2","501":"fe02916c","637":"8db0d393","694":"1da4d486","752":"c406480e","793":"dfe69f9d","982":"486b7fc5"}[chunkId] + ".chunk.js";
};